import React, { useState, useEffect } from 'react';
import axios from 'axios';
import params from '../config/Params';
import { getItemFromLocalStorage } from '../utils/storageUtils';
import { toast } from 'react-toastify';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import LoadingDots from './LoadingDots';
import Loader from './Loader';

const ListingStep18 = ({ formData, handleChange, prevStep, onRegisterSave }) => {
  const { listingId } = formData;
  const [listingData, setListingData] = useState([]);
  const [petAllowed, setPetAllowed] = useState(false);
  const [noOfPets, setNoOfPets] = useState(1);
  const [eventAllowed, setEventAllowed] = useState(false);
  const [smokingAllowed, setSmokingAllowed] = useState(false);
  const [commercialAllowed, setCommercialAllowed] = useState(false);
  const [guestAllowed, setGuestAllowed] = useState(1);
  const [additionalRules, setAdditionalRules] = useState('');
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [question, setQuestion] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);
  const [nextLoading, setNextLoading] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchListingData = async () => {
      const hostData = getItemFromLocalStorage('hostProfile');
      let formData = new FormData();
      formData.append('token', hostData.host_access_token);
      formData.append('listing_id', listingId);

      try {
        const response = await axios({
          method: 'post',
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          url: `${params.baseURL}${params.endpoints.getListingData}`,
          data: formData,
        });

        if (response.data.status === 'ok') {
          const listingData = response.data.updated_property_item;
          const { appr_list, resrv_list, offers, place_options_list } = listingData;
          setListingData(response.data.updated_property_item);
          setQuestion(response.data.updated_property_item.questions);
          setPetAllowed(listingData.rules_pet_allowed);
          setNoOfPets(listingData.rules_pet_count || 1);
          setEventAllowed(listingData.rules_event_allowed);
          setSmokingAllowed(listingData.rules_smoking_allowed);
          setCommercialAllowed(listingData.rules_commercial_allowed);
          setGuestAllowed(listingData.rules_no_of_guests_allowed || 1);
          setAdditionalRules(listingData.rules_additional);
          setLoading(false);
        } else {
          toast.error('An error occurred while fetching data.');
          setLoading(false);
        }
      } catch (err) {
        console.error(err.message);
        toast.error('Failed to load listing data.');
        setLoading(false);
      } finally {
        setLoading(false);
      }
    };

    fetchListingData();
  }, [listingId]);

  
    const saveListing = async () => {
      const hostData = getItemFromLocalStorage('hostProfile');
      const ts = Date.now();

      const updatedPropertyItem = {
        rules_pet_allowed: petAllowed,
        rules_pet_count: noOfPets,
        rules_event_allowed: eventAllowed,
        rules_smoking_allowed: smokingAllowed,
        rules_commercial_allowed: commercialAllowed,
        rules_no_of_guests_allowed: guestAllowed,
        rules_additional: additionalRules,
      };

      const mergedData = { ...listingData, ...updatedPropertyItem };

      let catData = new FormData();
      catData.append('token', hostData.host_access_token);
      catData.append('listing_id', listingId);
      catData.append('data', JSON.stringify(mergedData));
      catData.append('ts', ts);

      setNextLoading(true);

      try {
        const response = await axios({
          method: 'post',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          url: `${params.baseURL}${params.endpoints.updateListing}`,
          data: catData,
        });

        if (response.data.status === 'done') {
          return true;
        } else {
          toast.error('Failed to save data');
          return false;
        }
      } catch (err) {
        toast.error('An error occurred while saving the listing');
        return false;
      }
    };

    

  const handleIncrement = (value, setter, max = 10) => {
    if (value < max) {
      setter(value + 1);
    }
  };

  const handleDecrement = (value, setter, min = 1) => {
    if (value > min) {
      setter(value - 1);
    }
  };

  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };

  const faqs = [
    {
        question: "What is Lorem Ipsum?",
        answer: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."
    },
    {
        question: "Where does it come from?",
        answer: "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old."
    },
  ];
  
  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  if (loading) {
    return (
      <Loader />
    );
  }

  return (
    <div className="fade-in">
      <button id='host-listing-trigger-18' style={{ display: 'none' }} onClick={() => {
        if (onRegisterSave) {
          onRegisterSave(saveListing);
        }
      }}>Done</button>
      <div className='row'>
        {/*<div className='col-md-4 listing-img-box'>
          <div className='lsib'>
            <img src={'/assets/img/listing/listing_side_img.gif'} alt="Listing Image" className="listing-image" />
            {question && (
              <div className='lsqa-btn'>
                <StarButton text="Guide" link={question.find((q) => q.id === 18)?.link || '#'} />
              </div>
            )}
          </div>
        </div>*/}

        <div className='col-md-7'>

          <div className='ws-cl-header'>
            <div>
              <h4 className='ws-title'>House rules</h4>
              <p className='ws-desc'>Guests are expected to follow your rules, and can be removed from WIRE STAY if they cause issues.</p>
            </div>
          </div>

          <div className='st1-desc-box'>
            <div className='ws-row'>
              <div className='col-md-12'>
                <div className='house-rules-box'>
                  <div className='pets-box'>
                    <div className='rules-txt-box'>
                      <p>Pets allowed; service animals must be accommodated.</p>
                    </div>
                    <div className='btn-box'>
                      <label>
                        <input
                          type="checkbox"
                          checked={!petAllowed}
                          onChange={() => setPetAllowed(false)}
                        />
                        <span><i className="fas fa-times"></i></span>
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          checked={petAllowed}
                          onChange={() => setPetAllowed(true)}
                        />
                        <span><i className="fas fa-check"></i></span>
                      </label>
                    </div>
                  </div>
                  {petAllowed && (
                    <div className='allowed-box'>
                      <label className='st1-label'>Maximum number of pets allowed</label>
                      <div className="input-number-container">
                        <span className="input-number-decrement" onClick={() => handleDecrement(noOfPets, setNoOfPets)}>–</span>
                        <input
                          name='pets'
                          className="input-number"
                          type="number"
                          value={noOfPets}
                          readOnly
                        />
                        <span className="input-number-increment" onClick={() => handleIncrement(noOfPets, setNoOfPets)}>+</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className='col-md-12'>
                <div className='house-rules-box'>
                  <div className='pets-box'>
                    <div className='rules-txt-box'>
                      <p>Events allowed</p>
                    </div>
                    <div className='btn-box'>
                      <label>
                        <input
                          type="checkbox"
                          checked={!eventAllowed}
                          onChange={() => setEventAllowed(false)}
                        />
                        <span><i className="fas fa-times"></i></span>
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          checked={eventAllowed}
                          onChange={() => setEventAllowed(true)}
                        />
                        <span><i className="fas fa-check"></i></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div className='col-md-12'>
                <div className='house-rules-box'>
                  <div className='pets-box'>
                    <div className='rules-txt-box'>
                      <p>Smoking, vaping, e-cigarettes allowed</p>
                    </div>
                    <div className='btn-box'>
                      <label>
                        <input
                          type="checkbox"
                          checked={!smokingAllowed}
                          onChange={() => setSmokingAllowed(false)}
                        />
                        <span><i className="fas fa-times"></i></span>
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          checked={smokingAllowed}
                          onChange={() => setSmokingAllowed(true)}
                        />
                        <span><i className="fas fa-check"></i></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div className='col-md-12'>
                <div className='house-rules-box'>
                  <div className='pets-box'>
                    <div className='rules-txt-box'>
                      <p>Commercial photography and filming allowed</p>
                    </div>
                    <div className='btn-box'>
                      <label>
                        <input
                          type="checkbox"
                          checked={!commercialAllowed}
                          onChange={() => setCommercialAllowed(false)}
                        />
                        <span><i className="fas fa-times"></i></span>
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          checked={commercialAllowed}
                          onChange={() => setCommercialAllowed(true)}
                        />
                        <span><i className="fas fa-check"></i></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div className='col-md-12'>
                <div className='house-rules-box'>
                  <div className='rules-guest-box'>
                    <label className='st1-label'>Outside Guests</label>
                    <div className="input-number-container">
                        <span className="input-number-decrement" onClick={() => handleDecrement(guestAllowed, setGuestAllowed)}>–</span>
                        <input
                            name='guest'
                            className="input-number"
                            type="number"
                            value={guestAllowed}
                            readOnly
                        />
                        <span className="input-number-increment" onClick={() => handleIncrement(guestAllowed, setGuestAllowed)}>+</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className='col-md-12'>
                <div className='house-rules-box'>
                  <div className='pets-box'>
                    <div className='rules-txt-box'>
                      <p>Extended Policies</p>
                    </div>
                    <div className='btn-box'>
                      <button className='add-rule-btn' onClick={toggleDrawer(true)}>
                        <i className="fas fa-chevron-right"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

        </div>
        <div className='col-md-1'></div>
        <div className='col-md-4 p-0'>
          <div className='bfhsd'>
              <div className='blog-box'>
                  <div class="blog">
                      <div class="blog-image">
                          <img src={'https://app.wirestay.com/ws/uploads/blog/1736870810_pi.jpg'} className='img-fluid' alt="" />
                          <div class="date">May 08, 2025</div>
                      </div>
                      <div class="blog-content">
                          <h2>What is Lorem Ipsum?</h2>
                          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris vel metus vel est fermentum consectetur.</p>
                          <a href="#">Read More</a>
                      </div>
                  </div>
              </div>
              <div className="faq-sticky">
                  {faqs.map((faq, index) => (
                  <div key={index} className='faqs-list-section'>
                      <div
                      onClick={() => toggleAccordion(index)} className='faqs-qustn-box'
                      style={{
                          backgroundColor: activeIndex === index ? "#f7f7f7" : "#ffffff",
                      }}
                      >
                      {faq.question}
                      <i
                          className={`fas ${
                          activeIndex === index ? "fa-chevron-up" : "fa-chevron-down"
                          }`}
                          style={{
                          transition: "transform 0.3s ease",
                          }}
                      ></i>
                      </div>
                      {activeIndex === index && (
                      <div className='faqs-ans-box'>
                          {faq.answer}
                      </div>
                      )}
                  </div>
                  ))}
              </div>
          </div>
        </div>

      </div>

      <Dialog
        open={drawerOpen}
        onClose={toggleDrawer(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>EXTENDED POLICIES</DialogTitle>

        <DialogContent>
          <textarea
            value={additionalRules}
            onChange={(e) => setAdditionalRules(e.target.value)}
            placeholder="Add additional rules here"
            rows="5"
            style={{ width: '100%', padding: '10px', marginTop: '10px' }}
          />
        </DialogContent>

        <DialogActions style={{ justifyContent: 'space-between', padding: '16px 24px' }}>
          <button className="btn btn-blank dbBtn" style={{flex:'1'}} onClick={toggleDrawer(false)}>
            Close
          </button>
          <button className="btn btn-black dbBtn" style={{flex:'1'}} onClick={toggleDrawer(false)}>
            Done
          </button>
        </DialogActions>
      </Dialog>

    </div>
  );
};

export default ListingStep18;